import apiClient from "../core/HttpClient";

export default class GoogleCredentialsService{
    url = "/GoogleCredentials";
    async getGoogleCredentials() {
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });
    }

    /**
   * upload google credentials file
   */
  async googleCredentialsUpload(file:File){
      
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post(`${this.url}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
  }

  async signin(){
    return apiClient.get(`${this.url}/signin`);  
  }

}